import './polyfills'
import './parallax'
import './lightbox'
import initializeNewSlider from './slider_new'
import { Carousel } from './carousel'
import initializeHeader from './header'

const isMobile = () => innerWidth <= 1024

// Entry.
addEventListener('DOMContentLoaded', () => {

	// Tablet
	if (/(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(navigator.userAgent.toLowerCase())) {
		initializeHeader()
	}

	// iOS Specific
	if (/(iPod|iPhone|iPad|iOS)/gi.test(navigator.userAgent)) {
		document.body.classList.add("ios")
	}
	if (/(Android|iPod|iPhone|iPad|iOS)/gi.test(navigator.userAgent)) {
		document.body.classList.add('mobile')
	}

	Carousel.initializeAll()
	// initializeSlider()
	initializeNewSlider()
	initializeMenu()
	initializeParallaxHero()

	// Put focus on the search field, if present.
	const searchField = document.querySelector('#searchfield')
	if (searchField) {
		searchField.focus()
	}
})

//
// Main menu.
function initializeMenu() {
	// Toggler for mobile.
	const hamburgerButton = document.getElementById('hamburger')
	if (hamburgerButton) {
		const mobileMenu = document.getElementById('mobile_menu')
		hamburgerButton.addEventListener('click', (event) => {
			hamburgerButton.classList.toggle('open')
			mobileMenu.classList.toggle('open')
		})
	}

	const menuExpandButtons = document.querySelectorAll('.mobilesubopener')
	for (let a = 0; a < menuExpandButtons.length; a++) {
		menuExpandButtons[a].addEventListener('click', function (event) {
			this.classList.toggle('open')
		})
	}
}

function initializeParallaxHero() {
	const heroElement = document.querySelector('#hero')
	const heroContent = document.querySelector('section.main-image > div.content')
	if (!heroElement || !heroContent) {
		return
	}

	function scroll() {
		const scrollY = window.scrollY || window.pageYOffset || document.body.scrollTop || 0
		const offset = Math.min(scrollY / heroElement.offsetHeight, 1)
		const Y = (offset * heroElement.offsetHeight) * 0.8
	
		heroContent.style.opacity = 1 - offset
		heroContent.style.transform = `translateY(${Y}px)`
	}

	addEventListener('scroll', scroll)
	scroll()
}